export function isMobile() {
    return window.innerWidth <= 767;
}

export function isTablet() {
    return window.innerWidth <= 1200 && window.innerWidth > 767;
}

export function isTabletDown() {
    return window.innerWidth <= 1200;
}

export let breakpoints = {
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 1200px)',
    tabletDown: '(max-width: 1200px)',
    tabletUp: '(min-width: 768px)',
    desktop: '(min-width: 1201px)'
}